import {Autoplay, Navigation, Pagination} from 'swiper/modules'
import Swiper from 'swiper'

Swiper.use([Autoplay, Navigation, Pagination]);
document.addEventListener('DOMContentLoaded', () => {
  Array.prototype.forEach.call(document.querySelectorAll('.a-carousel'), (el) => {
    const swiper = new Swiper(el.querySelector('.swiper'), {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        clickable: true,
        el: el.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    swiper.on('slideChange', () => {
      window.dispatchEvent(new Event('lazy-load-check'))
    })
  });
});
